import { PHILOSOPHY } from "@/data/site";
import { MaskLines, Reveal, SectionLabel } from "@/components/Primitives";

export const Philosophy = () => (
  <section id="philosophy" className="border-t border-line bg-coal/40 py-28 sm:py-36 lg:py-44" data-testid="philosophy-section">
    <div className="container-x">
      <SectionLabel index="04" label="Philosophy" />
      <MaskLines
        lines={["Good Code Is Only", "The Beginning."]}
        className="mt-8 max-w-5xl font-serif text-5xl font-light leading-[1] text-ivory sm:text-6xl lg:text-7xl"
      />
      <div className="mt-20 grid grid-cols-1 border-t border-line md:grid-cols-3">
        {PHILOSOPHY.map((p, i) => (
          <Reveal
            key={p.n}
            delay={i * 0.12}
            className={`group py-10 md:px-10 md:py-14 ${i ? "border-t border-line md:border-l md:border-t-0" : ""} ${i === 0 ? "md:pl-0" : ""}`}
            data-testid={`philosophy-item-${p.n}`}
          >
            <span className="font-serif text-7xl font-light italic text-gold/90 transition-transform duration-700 group-hover:-translate-y-1 inline-block">{p.n}</span>
            <h3 className="mt-10 font-serif text-3xl text-ivory">{p.title}</h3>
            <p className="mt-4 max-w-xs leading-relaxed text-ash">{p.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
